import { HELP_COPY } from "../lib/helpCopy";
import { SAFETY_TASK_LABEL } from "../lib/projectTasksCopy";
import { InfoTooltip } from "./InfoTooltip";

// Sprint-017 E7 (design §4.2 / §5.3, CD Ruling Q2) — the "Safety task"
// toggle, rendered as a keyboard/SR-operable `role="switch"` row (NOT a
// long-press gesture — that has no keyboard/SR equivalent). Lives in two
// homes: above the person list in the assign picker, and per-row in Edit
// mode (so a member owner who never assigns can still mark Safety). 48px
// tall via `.pt-safety-toggle`.

export interface SafetySwitchProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  /** Distinguishes multiple switches on one screen for the label id. */
  idSuffix?: string;
}

export function SafetySwitch({ checked, onChange, idSuffix = "" }: SafetySwitchProps) {
  const labelId = `pt-safety-label${idSuffix}`;
  return (
    <div class="pt-safety-toggle">
      <span class="label-info-row">
        <span class="pt-safety-toggle-label" id={labelId}>
          {SAFETY_TASK_LABEL}
        </span>
        <InfoTooltip label={HELP_COPY.safetyTask.label} content={HELP_COPY.safetyTask.content} />
      </span>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-labelledby={labelId}
        class={`pt-switch${checked ? " is-on" : ""}`}
        onClick={() => onChange(!checked)}
      >
        <span class="pt-switch-knob" aria-hidden="true" />
      </button>
    </div>
  );
}
